const Colors = {
  Black: '#000',
  Blue00: '#00B7F1',
  Blue50: 'rgba(71, 181, 216, 0.5)',
  White: '#fff',
  White32: 'rgba(255, 255, 255, 0.32)',
  White50: 'rgba(255, 255, 255, 0.5)',
  White80: 'rgba(255, 255, 255, 0.8)',
  Transparent: 'transparent'
} as const

export { Colors as default }
